var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppErrorContainer',{attrs:{"errorTitle":"500","errorMsg":_vm.$t('error-msg'),"wIconSrc":require('@/assets/icons/pages/500.svg')}})}
var staticRenderFns = []

export { render, staticRenderFns }